module.exports = __webpack_public_path__ + "img/num_39.1cb5c489.png";